//loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LoaderService {
	public isLoading = new BehaviorSubject(false);
	public loadingGrowthChart$ = new BehaviorSubject(false);
	public loadingProgressTable$ = new BehaviorSubject(false);
	public loadingProgressBarClassroom$ = new BehaviorSubject(false);
	public loadingProgressBarSchool$ = new BehaviorSubject(false);
	public loadingAssessmentsBar$ = new BehaviorSubject(false);
	public loadingStudentTimeGraph$ = new BehaviorSubject(false);
	public loadingTestHistory$ = new BehaviorSubject(false);
	public loadingNotes$ = new BehaviorSubject(false);
	public loadingGrowthChartRaw$ = new BehaviorSubject(false);
	public StudentsPerChallange$ = new BehaviorSubject(false);

	constructor() {}
	public setLoadingGrowthChart(load: boolean) {
		this.loadingGrowthChart$.next(load);
	}
	public setLoadingGrowthChartRaw(load: boolean) {
		this.loadingGrowthChartRaw$.next(load);
	}
	get loading() {
		return this.isLoading.value;
	}
	public setLoading(value) {
		return this.isLoading.next(value);
	}
	get loadingGrowthChart() {
		return this.loadingGrowthChart$.value;
	}
	get loadingGrowthChartRaw() {
		return this.loadingGrowthChartRaw$.value;
	}

	public setLoadingProgressTable(load: boolean) {
		this.loadingProgressTable$.next(load);
	}

	get loadingProgressTable() {
		return this.loadingProgressTable$.value;
	}

	public setLoadingProgressBarClassRoom(load: boolean) {
		this.loadingProgressBarClassroom$.next(load);
	}

	get loadingProgressBarClassroom() {
		return this.loadingProgressBarClassroom$.value;
	}

	public setLoadingProgressBarSchool(load: boolean) {
		this.loadingProgressBarSchool$.next(load);
	}

	get loadingProgressBarSchool() {
		return this.loadingProgressBarSchool$.value;
	}
	get studentsPerChallange() {
		return this.StudentsPerChallange$.value;
	}

	public setLoadingAssessmentsBar(load: boolean) {
		this.loadingAssessmentsBar$.next(load);
	}

	get loadingAssessmentsBar() {
		return this.loadingAssessmentsBar$.value;
	}

	public setLoadingStudentTimeGraph(load: boolean) {
		this.loadingStudentTimeGraph$.next(load);
	}

	get loadingStudentTimeGraph() {
		return this.loadingStudentTimeGraph$.value;
	}

	public setLoadingTestHistory(load: boolean) {
		this.loadingTestHistory$.next(load);
	}

	get loadingTestHistory() {
		return this.loadingTestHistory$.value;
	}

	public setLoadingNotes(load: boolean) {
		this.loadingNotes$.next(load);
	}

	public setStudentsPerChallange(load: boolean) {
		this.StudentsPerChallange$.next(load);
	}

	get loadingNotes() {
		return this.loadingNotes$.value;
	}
}
